// Module
var code = `<download-widget ng-if="downloadWrapperController.isAuthenticated()"> </download-widget> `;
// Exports
module.exports = code;